var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_2015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 49.5C25.2422 49.5 22.5115 48.9568 19.9636 47.9015C17.4158 46.8461 15.1008 45.2993 13.1508 43.3492C11.2007 41.3992 9.65388 39.0842 8.59853 36.5364C7.54318 33.9885 7 31.2578 7 28.5C7 25.7422 7.54318 23.0115 8.59853 20.4636C9.65388 17.9158 11.2007 15.6008 13.1508 13.6508C15.1008 11.7007 17.4158 10.1539 19.9636 9.09853C22.5115 8.04318 25.2422 7.5 28 7.5C33.5695 7.5 38.911 9.46666 42.8492 12.9673C46.7875 16.468 49 21.216 49 26.1667C49 28.642 47.8938 31.016 45.9246 32.7663C43.9555 34.5167 41.2848 35.5 38.5 35.5H32.6667C31.6257 35.4832 30.609 35.815 29.7783 36.4427C28.9476 37.0703 28.3506 37.9577 28.0824 38.9636C27.8141 39.9696 27.89 41.0364 28.2978 41.9943C28.7057 42.9522 29.4222 43.7462 30.3333 44.25C30.7992 44.6799 31.1187 45.2449 31.2469 45.8657C31.3751 46.4866 31.3056 47.1319 31.0482 47.7112C30.7907 48.2905 30.3582 48.7746 29.8115 49.0954C29.2648 49.4162 28.6313 49.5577 28 49.5",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 26.1668C18.1442 26.1668 18.6666 25.6445 18.6666 25.0002C18.6666 24.3558 18.1442 23.8335 17.4999 23.8335C16.8556 23.8335 16.3333 24.3558 16.3333 25.0002C16.3333 25.6445 16.8556 26.1668 17.4999 26.1668Z",
    fill: "#FABA36",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 19.1668C28.6442 19.1668 29.1666 18.6445 29.1666 18.0002C29.1666 17.3558 28.6442 16.8335 27.9999 16.8335C27.3556 16.8335 26.8333 17.3558 26.8333 18.0002C26.8333 18.6445 27.3556 19.1668 27.9999 19.1668Z",
    fill: "#FABA36",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4999 26.1668C39.1443 26.1668 39.6666 25.6445 39.6666 25.0002C39.6666 24.3558 39.1443 23.8335 38.4999 23.8335C37.8556 23.8335 37.3333 24.3558 37.3333 25.0002C37.3333 25.6445 37.8556 26.1668 38.4999 26.1668Z",
    fill: "#FABA36",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_2015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.b6d46c2af9d394be213677ac4092ba2e.svg";
export { ForwardRef as ReactComponent };